<template>
    <div class="report-analysis-container" id="reportContainer" v-cloak>
        <div class="report-analysis-header">
            <!--顶部返回按钮-->
            <top-header @refresh-page="refreshPage"></top-header>
        </div>
        <div class="content-main">
            <div class="report-analysis-main" id="reportMain" :style="{width: tabName==='gradeTab'?'100%':'71.2%'}">
                <template v-if="Object.keys(summaryData).length === 0 && !isShowLoading">
                    <Row :gutter="12" style="margin-bottom: 12px;" class="statistic_wrap">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card class="statistic_card">
                            <p slot="title" class="card-title">
                                作业概况
                            </p>
                            <div class="statistic_content_wrap">
                                <!--布置作业数-->
                                <analysis-score-item :type="6"
                                                     :title="'布置作业数'"
                                                     :leftVal="'--'" :rightVal="'--'"></analysis-score-item>
                                <!--题目数量-->
                                <analysis-score-item :type="7"
                                                     :title="'题目数量'"
                                                     :leftVal="'--'"></analysis-score-item>
                                <!--平均提交率-->
                                <analysis-score-item :type="8"
                                                     :title="'平均提交率'"
                                                     :leftVal="'--'"></analysis-score-item>
                                <!--平均批改率-->
                                <analysis-score-item :type="9"
                                                     :title="'平均批改率'"
                                                     :leftVal="'--'"></analysis-score-item>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                    <!-- 暂无学生提交-->
                    <Row :gutter="12">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card>
                            <p slot="title" class="card-title">
                            </p>
                            <div class="no-data">
                                <img src="../../../assets/images/product/homework/no-data.png" alt="" class="no_pic">
                                <span class="txt">暂无作业概况数据哦~</span>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                </template>
                <template v-else>
                    <Row :gutter="12" style="margin-bottom: 12px;" class="statistic_wrap">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card class="statistic_card">
                            <p slot="title" class="card-title">
                                作业概况
                            </p>
                            <datedu-loading v-if="isShowLoading"></datedu-loading>
                            <div class="statistic_content_wrap" v-if="!isShowLoading">
                                <!--布置作业数-->
                                <analysis-score-item
                                    :title="'布置作业数'"
                                    :type="6"
                                    :leftVal="summaryData.hwSubmitNum"></analysis-score-item>
                                <!--题目数量-->
                                <analysis-score-item
                                    :title="'题目数量'"
                                    :type="7"
                                    :leftVal="summaryData.hwQuestionNum"></analysis-score-item>
                                <!--平均提交率-->
                                <analysis-score-item
                                    :title="'平均提交率'"
                                    :type="8"
                                    :leftVal="`${($utils.toDecimal(summaryData.hwSubmitRate*100)).toString()}%`"></analysis-score-item>
                                <!--平均批改率-->
                                <analysis-score-item
                                    :title="'平均批改率'"
                                    :type="9"
                                    :leftVal="`${($utils.toDecimal(summaryData.hwCorrectRate*100)).toString()}%`"></analysis-score-item>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                    <Row :gutter="12" style="margin-bottom: 10px;">
                        <Col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <double-pie-charts :chartsTitle="'不同作业类型的主、客观题占比'"
                                           :isShowMore=false
                                           :isClickCharts=false
                                           :chartsId="'hw_type_static'"
                                           :height="'443px'"
                                           :smallPieColorArr="smallPieColorArr"
                                           :bigPieColorArr="bigPieColorArr"
                                           :paramPieData="hwTypeStaticData"
                                           :isShowTitle=false
                                           ref="hwTypeStaticRef">
                        </double-pie-charts>
                        </Col>
                        <Col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                        <histogram-charts
                            :chartsTitle="'作业布置题量统计'"
                            :isShowMore=false
                            :isClickCharts=false
                            :chartsId="'hw_num_day'"
                            :height="'443px'"
                            :histogramTooltip="'hwNumDay'"
                            :colorArr="barColorArr"
                            :fontColor="barFontColor"
                            :isShowDataZoom=true
                            :isDisableDataZoom=false
                            :bottomHeight="'100px'"
                            ref="hwNumDayRef"
                        ></histogram-charts>
                        </Col>
                    </Row>
                    <Row :gutter="12" class="table-list">
                        <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <Card>
                            <p slot="title" class="card-title">
                                教师布置作业详情
                            </p>
                            <div slot="extra" class="table-list-right-btn">
                                <div class="table-list-right-search">
                                    <input placeholder="支持作业名称关键字搜索" class="big-data-input-cla"
                                           v-model="filters.keyWord"
                                           v-on:keyup.enter="handleSearch"/>
                                    <div class="big-data-search-btn" v-on:click="handleSearch">
                                        <div class="big-data-search-icon">
                                            <img src="../../../assets/images/databoard/detailPage/search.png"
                                                 width="100%" height="100%"/>
                                        </div>
                                    </div>
                                </div>
                                <Button type="ghost" class="table-list-right-btn-download"
                                        @click.native="downloadTableData()">
                                    <i class="export_icon"></i>
                                    导出
                                </Button>
                            </div>
                            <div class="table-content" :style="total && pageCount>1 ? 'padding-bottom: 57px;':''">
                                <div class="header">
                                    <Col :span="2">
                                    <span>序号</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>教师姓名</span>
                                    </Col>
                                    <Col :span="2">
                                    <span>学科</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>班级</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>作业名称</span>
                                    </Col>
                                    <Col :span="2">
                                    <span>类型</span>
                                    </Col>
                                    <Col :span="2">
                                    <span>主观题占比</span>
                                    </Col>
                                    <Col :span="3">
                                    <span>发送时间</span>
                                    </Col>
                                    <Col :span="4">
                                    <span>更多</span>
                                    </Col>
                                </div>
                                <div class="row-wrap">
                                    <template v-for="(item,index) in teacherDetailList">
                                        <Row :gutter="12" class="row-single"
                                             :class="index % 2 === 0 ? 'row-single':'row-double'">
                                            <Col :span="2">
                                            <span>{{(page - 1) * limit + index + 1}}</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.tea_name}}</span>
                                            </Col>
                                            <Col :span="2">
                                            <span>{{item.subject_name}}</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.class_name}}</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.title}}</span>
                                            </Col>
                                            <Col :span="2">
                                            <span v-if="item.tw_type==0">
                                                自定义
                                            </span>
                                            <span v-else>
                                                题库
                                            </span>
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='101'">-->
                                            <!--同步-->
                                            <!--</span>-->
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='102'">-->
                                            <!--复习-->
                                            <!--</span>-->
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='103'">-->
                                            <!--题库-->
                                            <!--</span>-->
                                            <!--<span v-if="item.tw_type==1 && subItem.tw_typecode=='104'">-->
                                            <!--校本-->
                                            <!--</span>-->
                                            </Col>
                                            <Col :span="2">
                                            <span>{{$utils.toDecimal(item.subject_Percentage*100)}}%</span>
                                            </Col>
                                            <Col :span="3">
                                            <span>{{item.biz_time}}</span>
                                            </Col>
                                            <Col :span="4">
                                            <span>
                                                <Button type="ghost"
                                                        @click="lookAnswerInfo(item.tea_id,item.hw_id,item.title,item.tw_type,item.tw_type)">查看作答详情</Button>
                                            </span>
                                            </Col>
                                        </Row>
                                    </template>
                                </div>
                                <div class="laypage_main">
                                    <Page :total="total" @on-change="handleCurrentChange" :current="page"
                                          v-if="total && pageCount>1"
                                          show-total></Page>
                                </div>
                            </div>
                        </Card>
                        </Col>
                    </Row>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        findTeacherSummary,
        findTeacherHwTypeStatic,
        findTeacherHwNumDayList,
        findTeacherDetailList
    } from "../../../service/bigDataApi.js";
    import {mapGetters} from 'vuex'

    const topHeader = () => import('../../../components/HwAnalysisTopHeader');
    const tabClassBar = () => import('../../../components/HwAnalysisTabClassBar');
    const AnalysisScoreItem = () => import('../../../components/HwAnalysisScoreItem');
    const dateduLoading = () => import('../../../components/DateduLoading');
    const DoublePieCharts = () => import("../../../components/charts/DoublePieCharts.vue");//柱状图
    const HistogramCharts = () => import("../../../components/charts/HistogramCharts.vue");//柱状图

    export default {
        name: "teacher-statis",
        data() {
            return {
                isShowLoading: true,//是否显示正在加载动画
                isShowLoadingByHwNumDay: true,
                screenWidth: 0,
                tabName: 'gradeTab',
                filters: {
                    keyWord: '',
                    teacherId: this.$route.query.teacherid,
                    subjectId: this.$route.query.subjectid,
                    startDate: this.$route.query.startdate,
                    endDate: this.$route.query.enddate
                },
                summaryData: {},//作业概况统计数据
                hwTypeStaticData: {},//不同类型作业的占比数据
                hwNumDayList: [],//每天部署作业数数据
                teacherDetailList: [],//作业详细列表数据
                smallPieColorArr: ['#61b9e9', '#FF6A68'],
                bigPieColorArr: ['#728FF2', '#F9A041', '#728FF2', '#F9A041'],
                barColorArr: [
                    {offset: 1, color: "#3E73F6"}
                ],
                barFontColor: '#757C8C',
                total: 0,
                page: 1,
                limit: 10, //每页个数
                pageCount: 0
            }
        },
        components: {
            topHeader,
            tabClassBar,
            AnalysisScoreItem,
            dateduLoading,
            DoublePieCharts,
            HistogramCharts
        },
        computed: {
            ...mapGetters([
                'homeWorkReportPath'
            ]),
        },
        methods: {
            /**
             * 获取教师作业概况
             */
            async getTeacherSummary() {
                let _this = this;
                let params = {
                    teacherid: _this.filters.teacherId,
                    startdate: _this.filters.startDate,
                    enddate: _this.filters.endDate,
                };
                let resultData = await findTeacherSummary(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });

                if (resultData.length > 0) {
                    this.summaryData = resultData[0];
                }
                this.isShowLoading = false;

                this.getTeacherHwTypeStatic();
            },
            /**
             * 获取教师布置作业中不同类型作业的占比
             */
            async getTeacherHwTypeStatic() {
                let _this = this;
                let params = {
                    teacherid: _this.filters.teacherId,
                    startdate: _this.filters.startDate,
                    enddate: _this.filters.endDate
                };
                this.hwTypeStaticData = await findTeacherHwTypeStatic(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });

                this.getTeacherHwNumDayList();

            },
            /**
             * 获取教师每天部署作业数
             */
            async getTeacherHwNumDayList() {
                let _this = this;
                let params = {
                    teacherid: _this.filters.teacherId,
                    startdate: _this.filters.startDate,
                    enddate: _this.filters.endDate
                };
                this.hwNumDayList = await findTeacherHwNumDayList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });

                let nameArr = [];
                let numArr = [];
                for (let i = 0; i < _this.hwNumDayList.length; i++) {
                    nameArr.push(_this.hwNumDayList[i].date);
                    numArr.push(_this.hwNumDayList[i].hw_num);
                }
                _this.$nextTick(() => {
                    //渲染图表
                    _this.$refs.hwNumDayRef.initDataSource(_this.hwNumDayList, nameArr, numArr);
                });

                this.isShowLoadingByHwNumDay = false;
                this.getTeacherDetailList();
            },
            /**
             * 获取教师作业详细列表
             */
            async getTeacherDetailList() {
                let _this = this;
                let params = {
                    // teacherid: _this.filters.teacherId,
                    teacherid: "859b4796127e45f195aae7bb09665aee",
                    startdate: _this.filters.startDate,
                    enddate: _this.filters.endDate,
                    keyword:_this.filters.keyWord,
                    pageno:_this.page,
                    pagesize:_this.limit

                };
               let resultData = await findTeacherDetailList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                this.teacherDetailList=resultData.rows;
                this.total=resultData.total_rows;
                this.pageCount=resultData.page_count;
            },
            /**
             * 导出表格数据
             */
            downloadTableData() {
                // let url =
                //     BASE_URL +
                //     "/homework/statsanalysis/exportWorkScore?workId=" +
                //     this.homeworkId +
                //     "&classId=" +
                //     this.classId;
                // let iframe = document.createElement("iframe");
                // iframe.style.display = "none";
                // iframe.src = url;
                // iframe.onload = function () {
                //     document.body.removeChild(iframe);
                // };
                // document.body.appendChild(iframe);
            },
            /**
             * 刷新页面
             */
            refreshPage() {
                if (this.tabName === 'gradeTab') {
                    // //成绩分析
                    this.getTeacherSummary();
                } else {
                    // //答题分析
                    // this.answerStatisticData = [];
                    // this.spinShow = true;
                    //
                    // this.loadAnswerStatistic();
                }
            },
            /**
             * 查看单个作业的作答详情
             */
            lookAnswerInfo(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
                let reportUrl = "";
                //答题卡
                if (hwType == 0) {
                    //web
                    reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                } else if (hwType == 1) {
                    if (hwTypeCode == '103') {
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/jingyouReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                    } else if (hwTypeCode == '104') {
                        //菁优题库
                        reportUrl = this.homeWorkReportPath + '/xbReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                    } else {
                        //题库
                        reportUrl = this.homeWorkReportPath + '/questionBankReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.filters.subjectId;
                    }
                }
                window.open(reportUrl, "_blank");
            },
            /**
             *翻页
             */
            handleCurrentChange(val) {
                this.page = val;
                //根据作业id和班级id获取学生得分列表
                this.getTeacherDetailList();
            },
            /**
             * 搜索
             */
            handleSearch() {
                this.page = 1;
                this.getTeacherDetailList();
            },
            /**
             * 计算各dom高度
             */
            calDomHeight() {
                let _this = this;
                $(".report-analysis-main").css("height", $(window).height() - 85);
                $(".right-container").css("height", $(window).height() - 85);
                $(".right-container").css("minHeight", $(window).height() - 87);
                $(".question-wrap").css("height", $(window).height() - 85);
                $(".question-wrap").css("minHeight", $(window).height() - 85);
                $(".question-wrap").find('.ivu-card-body').css("minHeight", $(window).height() - 87);
                $(".right-container").find('.ivu-card-body').css("minHeight", $(window).height() - 87);
            },
        },
        mounted() {
            let _this = this;
            //获取屏幕宽度
            this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            this.getTeacherSummary();

            _this.$nextTick(() => {
                setTimeout(function () {
                    //动态计算各dom高度
                    _this.calDomHeight();
                }, 300)
            });
            //当浏览器大小变化时
            $(window).resize(function () {
                //动态计算各dom高度
                _this.calDomHeight();
            });
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/product/homework/reportList";
</style>

<style lang="scss">
    @import "../../../style/product/homework/statisMain";
    .laypage_main{
        .ivu-page-item-active a, .ivu-page-item-active:hover a {
            color: #fff!important;
        }
    }
</style>
